import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroGuaritaLista {
  lastSetDefault: Date;

  DC5EMISSAO_DE: Date | undefined;
  DC5EMISSAO_ATE: Date | undefined;
  CC5GUARITA: string;
  CLISTACOMPLEMENTO: string;
  CC5NUM: string;
}

export class FiltroGuaritaLista {

  dados: IFiltroGuaritaLista;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-lista-faturamento-guarita';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroGuaritaLista) => {
      if (filtro) {

        const {
          lastSetDefault,
          CC5GUARITA,
          DC5EMISSAO_DE,
          DC5EMISSAO_ATE,
          CLISTACOMPLEMENTO
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            CC5GUARITA: CC5GUARITA,
            DC5EMISSAO_DE: DC5EMISSAO_DE ? new Date(DC5EMISSAO_DE) : undefined,
            DC5EMISSAO_ATE: DC5EMISSAO_ATE ? new Date(DC5EMISSAO_ATE) : undefined,
            CLISTACOMPLEMENTO: CLISTACOMPLEMENTO,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroGuaritaLista => {
    return {
      lastSetDefault: new Date(),
      DC5EMISSAO_DE: this.getData(-7),
      DC5EMISSAO_ATE: new Date(),
      CC5NUM: '',
      CC5GUARITA: '',
      CLISTACOMPLEMENTO: 'N'
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
